<template>
  <div class="serial-head">
    <strong class="cxStrong"
      ><a :href="serialData.link" target="_blank" @click="countAd(4157)"
        ><em>{{ serialData.name }}</em
        >的车系频道</a
      ></strong
    >
    <div class="carsBox">
      <div class="cxBox cxBox1">
        <div class="czTop">
          <div class="left">
            <a :href="serialData.link" target="_blank" @click="countAd(4158)"
              ><img :src="serialData.logo || $carsDefaultImgUrl"
            /></a>
          </div>
          <div class="right">
            <p>
              <strong
                ><a
                  :href="serialData.link"
                  target="_blank"
                  @click="countAd(4159)"
                  >{{ serialData.name }}</a
                ></strong
              >
              <span v-if="serialData.discount">
                <span class="label">优惠：</span>
                <a
                  :href="serialData.discount_link"
                  target="_blank"
                  class="green"
                  @click="countAd(4160)"
                  >{{ serialData.discount }}</a
                >
              </span>
            </p>
            <p>
              <span class="label">{{ priceTitText1 }}:</span>
              <span class="red"
                ><a
                  :href="serialData.price_link"
                  target="_blank"
                  @click="countAd(4161)"
                  >{{ priceText }}</a
                ></span
              >
              <span class="label p25"
                >{{ serialData.region_name }}商家报价：</span
              >
              <span class="red" v-if="serialData.d_price"
                ><a
                  :href="serialData.d_price_link"
                  target="_blank"
                  @click="countAd(4162)"
                  >{{ serialData.d_price }}</a
                ></span
              >
            </p>
            <p class="btns">
              <a
                :href="serialData.labels[1].link"
                target="_blank"
                @click="countAd(4163)"
                >{{ serialData.labels[1].label }}</a
              >
              <a
                :href="serialData.labels[0].link"
                target="_blank"
                @click="countAd(4164)"
                >{{ serialData.labels[0].label }}({{
                  serialData.photo_total
                }})</a
              >
              <a
                :href="serialData.labels[5].link"
                target="_blank"
                @click="countAd(4165)"
                >{{ serialData.labels[5].label }}</a
              >
              <a
                :href="serialData.labels[4].link"
                target="_blank"
                @click="countAd(4166)"
                >{{ serialData.labels[4].label }}报价</a
              >
              <a
                :href="serialData.labels[2].link"
                target="_blank"
                @click="countAd(4167)"
                >{{ serialData.labels[2].label }}</a
              >
              <a
                :href="serialData.labels[3].link"
                target="_blank"
                @click="countAd(4168)"
                >{{ serialData.labels[3].label }}</a
              >
            </p>
            <p class="canal">
              <a
                class="xdj"
                :href="`https://qdfront.pcauto.com.cn/order/pc/common/order_detail.xsp?t=0&amp;sgid=${serialData.id}`"
                target="_blank"
                data-ask-price-entry="disabled"
                :data-sgid="serialData.id"
                @click="countAd(4169)"
                v-if="!noXdjBtn"
                >获取底价</a
              >
              <span v-else class="nobtn">获取底价</span>
              <a
                class="fgc"
                :href="`//jr.pcauto.com.cn/autofinance/commorders/order.jsp?sgid=${serialData.id}`"
                target="_blank"
                data-ask-price-entry="disabled"
                :data-sgid="serialData.id"
                @click="countAd(4170)"
                v-if="!noXdjBtn"
                >分期购车</a
              >
              <span v-else class="nobtn">分期购车</span>
              <a
                class="ysz"
                :href="`https://qdfront.pcauto.com.cn/order/pc/common/order_detail.xsp?sgid=${serialData.id}&amp;t=2`"
                target="_blank"
                data-ask-price-entry="disabled"
                :data-sgid="serialData.id"
                @click="countAd(4171)"
                v-if="!noXdjBtn"
                >预约试驾</a
              >
              <span v-else class="nobtn">预约试驾</span>
              <a
                class="zbt"
                :href="`https://qdfront.pcauto.com.cn/order/pc/common/order_detail.xsp?sgid=${serialData.id}&amp;t=4`"
                target="_blank"
                data-ask-price-entry="disabled"
                :data-sgid="serialData.id"
                @click="countAd(4172)"
                v-if="!noXdjBtn"
                >置换补贴</a
              >
              <span v-else class="nobtn">置换补贴</span>
            </p>
          </div>
        </div>
        <div class="cxTable" id="cxTable" v-if="serialData.tabs.length > 0">
          <div class="stages" v-if="installmentPrice">
            分期：<a
              :href="`//jr.pcauto.com.cn/autofinance/commorders/order.jsp?sgid=${serialData.id}#ad=8398`"
              target="_blank"
              @click="countAd(4173)"
              >月供{{ installmentPrice }}元起</a
            >
          </div>
          <ul class="cxTableUl">
            <li
              v-for="(tab, index) in serialData.tabs"
              :key="index"
              @mouseenter="changTab(index)"
              :class="{ on: currentTab === index }"
            >
              {{ tab.title }}
            </li>
          </ul>
          <div
            class="cxTableCont chatables"
            v-show="index === currentTab"
            v-for="(tab, index) in serialData.tabs"
            :key="index"
          >
            <p class="cxTableTh">
              <span class="th1">车型名称</span>
              <span class="th2">{{ priceTitText2 }}</span>
              <span class="th3">本地最低价</span>
            </p>
            <p
              class="cxTableTr border4"
              v-for="(model, i) in tab.models"
              :key="i"
            >
              <span class="th1">
                <a :href="model.link" target="_blank" @click="countAd(4175)">{{
                  model.name
                }}</a>
              </span>
              <span class="th2">
                <a
                  :href="model.price_link"
                  target="_blank"
                  @click="countAd(4176)"
                  >{{
                    serialData.isNewPower == 1 ? model.btPrice : model.price
                  }}</a
                >
              </span>
              <span class="th3">
                <a
                  :href="model.min_price_link"
                  target="_blank"
                  class="min-pirce"
                  @click="countAd(4177)"
                  >{{
                    model.min_price == "暂无报价"
                      ? model.price
                      : model.min_price
                  }}</a
                >
                <a
                  :href="`//jr.pcauto.com.cn/autofinance/commorders/order.jsp?sgid=${sid}#ad=8401`"
                  target="_blank"
                  class="phase"
                  data-ask-price-entry="disabled"
                  :data-sgid="serialData.id"
                  @click="countAd(4178)"
                  v-if="!noXdjBtn"
                  >分期购车</a
                >
                <span v-else class="nobtn">分期购车</span>
                <a
                  :href="`https://qdfront.pcauto.com.cn/order/pc/common/order_detail.xsp?t=0&mid=${model.id}#ad=8402`"
                  target="_blank"
                  class="btn"
                  data-ask-price-entry="disabled"
                  :data-sgid="serialData.id"
                  @click="countAd(4179)"
                  v-if="!noXdjBtn"
                  >获取底价</a
                >
                <span v-else class="nobtn">获取底价</span>
              </span>
            </p>
          </div>
        </div>
        <a
          :href="`//price.pcauto.com.cn/sg${serialData.id}/price.html#ad=5439`"
          v-if="serialData.tabs.length > 0"
          target="_blank"
          class="more"
          @click="countAd(4180)"
          >查看<em>{{ serialData.name }}</em
          >的全部车型</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SerialHead",
  props: {
    serialData: {
      type: Object,
      default: () => ({}),
    },
    sid: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      currentTab: 0, //车系顶部热门车型tab切换,当前tab
      installmentPrice: 0, // 本地车系分期月供价格
    };
  },
  methods: {
    changTab(index) {
      this.currentTab = index;
      this.countAd(4174);
    },
    //获取本地分期价格
    async reqSerialInstallment(sgId, regionId) {
      try {
        const res = await this.fetSerialInstallment({
          sgId,
          regionId,
        });
        if (res.products.length > 0) {
          this.installmentPrice = res.products[0].monthlyPay;
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
  computed: {
    noXdjBtn() {
      return (
        this.serialData.sellStatus === 1 &&
        (this.serialData.brandId === 845 ||
          (this.serialData.id === 215 && this.serialData.brandId === 78))
      );
    },
    priceTitText1() {
      let str;
      if (this.serialData.isNewPower === 1) {
        str = "官方报价";
      } else if (
        this.serialData.isNewPower != 1 &&
        this.serialData.sellStatus === 4
      ) {
        str = "预售价";
      } else if (
        this.serialData.isNewPower != 1 &&
        this.serialData.sellStatus != 4
      ) {
        str = "官方报价";
      }
      return str;
    },
    priceTitText2() {
      let str;
      if (this.serialData.isNewPower === 1) {
        str = "官方报价";
      } else if (
        this.serialData.isNewPower != 1 &&
        this.serialData.sellStatus === 4
      ) {
        str = "预售价";
      } else if (
        this.serialData.isNewPower != 1 &&
        this.serialData.sellStatus != 4
      ) {
        str = "官方报价";
      }
      return str;
    },
    priceText() {
      // let price;
      // if (this.serialData.isNewPower === 1) {
      //   price = this.serialData.btPriceRange;
      // } else {
      //   price = this.serialData.price;
      // }
      return (this.serialData && this.serialData.price) || "暂无报价";
    },
  },
  watch: {
    serialData: {
      handler: function () {
        this.$nextTick(() => {
          window.AskPriceEntryHandler && window.AskPriceEntryHandler.reset();
        });
      },
      deep: true,
    },
  },
  mounted() {
    this.reqSerialInstallment(this.sid, this.$global.rid);
    this.$nextTick(() => {
      window.AskPriceEntryHandler && window.AskPriceEntryHandler.reset();
    });
  },
};
</script>

<style lang="scss" scoped>
.serial-head {
  margin-bottom: 25px;
  .cxStrong {
    font-weight: normal;
    font-size: 16px;
    line-height: 36px;
    // margin-top: 16px;
    display: inline-block;
    a {
      text-decoration: underline;
      color: #225599;
    }
    em {
      color: #cc0000;
      text-decoration: underline;
      font-style: normal;
    }
  }
  .cxTableCont {
    padding: 0 15px;
    box-sizing: border-box;
    span {
      float: left;
    }
  }
  .carsBox {
    border: 1px solid #e5e5e5;
    .cxBox {
      width: 618px;
      border: 1px solid #d7d7d7;
      padding-bottom: 1px;
      .cxBox1 {
      }
      .czTop {
        margin: 10px 10px 0;
        display: flex;
        justify-content: space-between;
        .left {
          margin: 1px 0 0 1px;
          img {
            width: 160px;
            height: 120px;
          }
        }
        .right {
          p {
            width: 422px;
            height: 26px;
            line-height: 26px;
            strong {
              a {
                font-size: 14px;
                color: #225599;
                margin-right: 13px;
              }
            }
          }
          .label {
            color: #777777;
          }
          .red {
            font-weight: bold;
            position: relative;
            a {
              color: #cc0000;
            }
          }
          .btns {
            display: flex;
            a {
              color: #259;
              text-decoration: underline;
              width: auto;
              margin-right: 10px;
              font-size: 14px;
            }
          }
          .canal {
            display: flex;
            height: 30px;
            margin-top: 7px;
            a,
            span {
              text-align: center;
              border: 1px solid #ebebeb;
              height: 28px;
              width: 74px;
              margin-right: 8px;
            }
            .xdj {
              border: 1px solid #ebebeb;
              color: #fff;
              background: #fd9827;
            }
            .nobtn {
              border: none;
              color: #fff;
              box-sizing: border-box;
              background: #ebebeb;
              cursor: not-allowed;
            }
            .fgc {
              border: 1px solid #ebebeb;
              color: #fff;
              background: #369fe0;
            }
            .ysz {
              border: 1px solid #ebebeb;
              color: #333333;
            }
            .zbt {
              border: 1px solid #ebebeb;
              color: #333333;
            }
          }
        }
      }
    }
  }
  .cxTable {
    // height: 220px;
    overflow: hidden;
    padding-top: 10px;
    position: relative;
  }
  .stages {
    position: absolute;
    font-weight: 700;
    right: 14px;
    top: 13px;
    color: #999;
    z-index: 2;
    a {
      color: #cc0000;
    }
  }
  .cxTableUl {
    text-align: center;
    line-height: 25px;
    height: 25px;
    border-top: 1px solid #e3e3e3;
    border-bottom: 1px solid #e3e3e3;
    display: flex;
    position: relative;
    z-index: 1; /* 层级问题,有可能会挡住联想词 */
    li {
      width: 85px;
      height: 25px;
      border: 1px solid #e3e3e3;
      margin: -1px 0 0 -1px;
      cursor: pointer;
      position: relative;
      z-index: 99;
      font-size: 12px;
    }
    .on {
      border: 0;
      border-top: 2px solid #225599;
      font-size: 12px;
      color: #225599;
      height: 24px;
      line-height: 24px;
      border-bottom: 2px solid #ffffff;
      border-right: 1px solid #e3e3e3;
    }
  }
  .cxTableTh {
    font-weight: bold;
    border-bottom: 1px solid #f1f1f1;
    height: 29px;
    line-height: 29px;
    .th1 {
      display: inline-block;
      width: 293px;
    }
    .th2 {
      display: inline-block;
      width: 65px;
    }
    .th3 {
    }
  }

  .cxTableTr {
    height: 29px;
    line-height: 29px;
    overflow: hidden;
    span {
      overflow: hidden;
    }
    .th1 {
      width: 293px;
      display: inline-block;
      a {
        color: #225599;
      }
    }
    .th2 {
      width: 65px;
      display: inline-block;
      a {
        color: #333333;
      }
    }
    .th3 {
      a {
        color: #cc0000;
      }
      .min-pirce {
        display: inline-block;
        min-width: 52px;
      }
      .phase {
        width: 70px;
        color: #666;
        padding: 4px 10px;
        width: auto;
        text-align: center;
        border: 1px solid #e4e4e4;
        margin-top: 4px;
        white-space: nowrap;
        margin-left: 25px;
      }
      .btn {
        padding: 5px 10px;
        margin-left: 15px;
        width: auto;
        color: #fff;
        text-align: center;
        background: #fd9827;
        height: 12px;
        line-height: 12px;
        margin-top: 4px;
        white-space: nowrap;
        &:hover {
          color: #ffffff !important;
          background-color: #fb6523;
        }
      }
    }
  }
  .more {
    display: block;
    text-align: center;
    background: #f4f4f4;
    width: 616px;
    height: 26px;
    line-height: 26px;
    margin: 0 auto;
    color: #333333;
    &:hover {
      em {
        color: #ff6600;
      }
    }
    em {
      color: #225599;
      font-style: normal;
    }
  }
  .p25 {
    padding-left: 25px;
  }
  .border4 {
    border-bottom: 1px dashed #f1f1f1;
  }
  .green {
    color: #339900;
    font-weight: bold;
    position: relative;
    left: -5px;
    font-family: "";
  }
}
</style>